import { useMutation, useQueryClient } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { buildApiUrl } from '@/utils/build-api-url.ts';
import { useAuth } from '@clerk/clerk-react';
import { GET_EVENT_QUERY_KEY } from '../../queries/events/use-get-event.ts';
import type { SendEventContributorsInvitationsDto } from '@/types/dtos/events/request/send-event-contributors-invitations.dto.ts';
import { GET_EVENT_CONTRIBUTORS_QUERY_KEY } from '@/state/queries/contributors/use-get-event-contributors.ts';

export const useSendEventContributorsInvitations = () => {
  const { getToken } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (sendEventData: SendEventContributorsInvitationsDto) => {
      const token = await getToken();
      return sendEventContributorInvitations(sendEventData, token ?? '');
    },
    onSuccess: () => {
      return Promise.all([
        queryClient.invalidateQueries({
          queryKey: [GET_EVENT_QUERY_KEY],
        }),
        queryClient.invalidateQueries({
          queryKey: [GET_EVENT_CONTRIBUTORS_QUERY_KEY],
        }),
      ]);
    },
  });
};

const sendEventContributorInvitations = async (
  { eventId, contributors }: SendEventContributorsInvitationsDto,
  token: string,
) => {
  const url = buildApiUrl(`invitations/event/${eventId}/contributors`);
  return sendJSONRequest({ url, method: METHOD.POST, token, body: { contributors } });
};

export default useSendEventContributorsInvitations;
